// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  white-space: normal !important;
  overflow: visible !important;
}

.spacing-container {
  padding: 20px;
}

.button-small {
  font-weight: 700;
  font-size: 16px;
  height: 44px;
}

@media screen and (max-width: 420px) {
  .resend-pin-container {
    display: none;
  }
}

.resend-button-container-small {
  display: none;
}
@media screen and (max-width: 420px) {
  .resend-button-container-small {
    display: block;
  }
}

.resend-btn {
  transform: translateY(32px);
}

.highlight {
  color: red !important;
}

ion-select.mobile-select {
  border: 1px solid #666;
}
ion-select.mobile-select .item-cover {
  width: 0;
  height: 0;
}

.center-item-options {
  display: flex !important;
  justify-content: center !important;
}

ion-select.select {
  margin: auto;
}

.ios-checkbox ion-checkbox::part(container) {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/self-exclude/self-exclude.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,4BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,YAAA;AACJ;;AAEI;EADJ;IAEQ,aAAA;EAEN;AACF;;AAAA;EACI,aAAA;AAGJ;AAFI;EAFJ;IAGQ,cAAA;EAKN;AACF;;AAFA;EACI,2BAAA;AAKJ;;AAFA;EACI,qBAAA;AAKJ;;AAHA;EACI,sBAAA;AAMJ;AALI;EACI,QAAA;EACA,SAAA;AAOR;;AAJG;EACC,wBAAA;EACA,kCAAA;AAOJ;;AALE;EACE,YAAA;AAQJ;;AANA;EACI,kBAAA;AASJ","sourcesContent":["ion-label {\r\n    white-space: normal !important;\r\n    overflow: visible !important;\r\n}\r\n\r\n.spacing-container {\r\n    padding: 20px;\r\n}\r\n\r\n.button-small {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    height: 44px;\r\n}\r\n.resend-pin-container{\r\n    @media screen and (max-width:420px){\r\n        display:none;\r\n    }\r\n}\r\n.resend-button-container-small{\r\n    display: none;\r\n    @media screen and (max-width:420px){\r\n        display: block;\r\n    }\r\n}\r\n\r\n.resend-btn{\r\n    transform: translateY(32px);\r\n}\r\n\r\n.highlight {\r\n    color: red !important;\r\n}\r\nion-select.mobile-select {\r\n    border: 1px solid #666;\r\n    .item-cover {\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n  }\r\n   .center-item-options {\r\n    display: flex !important; \r\n    justify-content: center !important;\r\n  }\r\n  ion-select.select {\r\n    margin: auto;\r\n  }\r\n.ios-checkbox ion-checkbox::part(container) {\r\n    border-radius: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
